// Audio Player Constants
export const WAVEFORM_HEIGHT = 100;
export const BAR_WIDTH = 2;
export const BAR_RADIUS = 3;
export const BAR_GAP = 1;
export const CURSOR_WIDTH = 2;
export const ZOOM_STEP = 10;
export const MIN_ZOOM = 1;
export const MAX_ZOOM = 100;
export const REGION_COLOR = 'rgba(251, 191, 36, 0.3)';
export const MIN_REGION_LENGTH = 0.1;

// Large file threshold - files over this size will use procedural waveform
// to avoid browser memory issues (105MB)
export const LARGE_FILE_THRESHOLD = 105 * 1024 * 1024;

// Format time in seconds to HH:MM:SS or MM:SS
export const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return '00:00';
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);
    
    const pad = (n) => n.toString().padStart(2, '0');
    return `${h > 0 ? pad(h) + ':' : ''}${pad(m)}:${pad(s)}`;
};

// Generate theme colors based on dark mode
export const getThemeColors = (isDarkMode) => ({
    bgPrimary: isDarkMode ? '#0f172a' : '#f8fafc',
    bgSecondary: isDarkMode ? '#1e293b' : '#ffffff',
    bgTertiary: isDarkMode ? '#1e293b' : '#f8fafc',
    border: isDarkMode ? '#1e293b' : '#e2e8f0',
    borderSecondary: isDarkMode ? '#334155' : '#e2e8f0',
    text: isDarkMode ? '#94a3b8' : '#64748b',
    textPrimary: isDarkMode ? '#e2e8f0' : '#1e293b',
    textSecondary: isDarkMode ? '#64748b' : '#94a3b8',
    buttonBg: isDarkMode ? '#3b82f6' : '#2563eb',
    buttonHover: isDarkMode ? '#2563eb' : '#1d4ed8',
    buttonDisabled: isDarkMode ? '#334155' : '#cbd5e1',
    hoverBg: isDarkMode ? '#334155' : '#f1f5f9',
    divider: isDarkMode ? '#334155' : '#cbd5e1'
});

// Generate box shadow based on dark mode
export const getBoxShadow = (isDarkMode) => 
    isDarkMode 
        ? '0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 2px 4px -1px rgba(0, 0, 0, 0.2)' 
        : '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';

// Generate WaveSurfer configuration
// For large files, we skip the backend option as we'll use pre-computed peaks
export const getWaveSurferConfig = (isDarkMode, isLargeFile = false) => {
    const baseConfig = {
        waveColor: isDarkMode ? '#60a5fa' : '#3b82f6',
        progressColor: isDarkMode ? '#93c5fd' : '#1d4ed8',
        cursorColor: '#ef4444',
        barWidth: BAR_WIDTH,
        barRadius: BAR_RADIUS,
        cursorWidth: CURSOR_WIDTH,
        height: WAVEFORM_HEIGHT,
        barGap: BAR_GAP,
        responsive: true,
        normalize: true
    };
    
    // For large files, we don't need WebAudio backend since we provide pre-computed peaks
    // This prevents memory issues with large audio files
    if (!isLargeFile) {
        baseConfig.backend = 'WebAudio';
    }
    
    return baseConfig;
};

